// extracted by mini-css-extract-plugin
module.exports = {"scrollBox":"DeviceComponentsHistory_scrollBox__18Eii","noRightPadding":"DeviceComponentsHistory_noRightPadding__2YKWi"};